module.exports = __webpack_public_path__ + "bac06047a6ab7ada76ba1c24b6931c22.pdf";